module.exports = __webpack_public_path__ + "img/icon-cancel.c4b513be.svg";